module.exports = __webpack_public_path__ + "img/Bathroom.fix.4573e98f.jpeg";